import { Text, TextAlignment, TokenTextAppearance, TokenTextColor } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Carline, SalesgroupWithCarline } from '../../../../../types/vehicle-types';
import { EtiquetaDGTImg, EtiquetasRow } from '../ui/vehicle-section-styles';
import { useVehicleImage } from './hooks/use-vehicle-image';
import { VehicleCard, VehicleCardImage, VehicleCardImageContainer } from './ui/vehicle-card-styles';

interface Props {
	option: Carline | SalesgroupWithCarline;
	isActive?: boolean;
	hasError?: boolean;
	onSelect?: (e: React.MouseEvent) => void;
}

export function VehicleCardRadio(props: Props) {
	const { option, isActive = false, hasError = false, onSelect } = props;

	const { displayImage, etiquetas, setIsImageLoaded } = useVehicleImage({ option, loadLateralImage: false });
	const carline = 'carline' in option ? option.carline : option;

	return (
		<VehicleCard
			isActive={isActive}
			hasError={!isActive && hasError}
			onClick={onSelect}
			onMouseDown={(e) => e.preventDefault()}
		>
			<EtiquetasRow>
				{etiquetas.length > 0 && (
					<>
						{etiquetas.map((src, i) => (
							<EtiquetaDGTImg key={i} src={src} alt="Etiqueta DGT" index={i} />
						))}
					</>
				)}
			</EtiquetasRow>

			<VehicleCardImageContainer>
				<VehicleCardImage
					src={displayImage({ lateral: false })}
					alt={option.title}
					onError={() => setIsImageLoaded(false)}
				/>
			</VehicleCardImageContainer>

			<Text
				appearance={TokenTextAppearance.copy100}
				color={TokenTextColor.primary}
				textAlign={TextAlignment.center}
				bold
			>
				{Boolean(carline.nuevo) && 'Nuevo' + ' '}
				{option.title}
			</Text>
		</VehicleCard>
	);
}
